/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskQueuesLandingType from '@jira/spa-apps__servicedesk-queues-landing/src/ExportedDefault.tsx';
import type { Props } from '@jira/spa-apps__servicedesk-queues-landing/src/SrcProps.types.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskQueuesLanding: LazyComponent<
	React.FunctionComponent<
		Omit<
			Omit<Props, never> & Partial<unknown>,
			'QueuesAppBase' | 'QueuesRedirect' | 'AvailableQueuesConsumer'
		>
	>
> = lazyForPaint<typeof ServicedeskQueuesLandingType>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-queues-landing", jiraSpaEntry: "async-servicedesk-queues-landing" */ '@jira/spa-apps__servicedesk-queues-landing/src/ExportedDefault.tsx'
		),
);

const AsyncServicedeskQueuesLanding = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskQueuesLanding}
		pageId="spa-apps/servicedesk/queues/landing"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskQueuesLanding;
